import { render, staticRenderFns } from "./EdicaoInternacao.vue?vue&type=template&id=51fc2255&scoped=true&"
import script from "./EdicaoInternacao.vue?vue&type=script&lang=js&"
export * from "./EdicaoInternacao.vue?vue&type=script&lang=js&"
import style0 from "./EdicaoInternacao.vue?vue&type=style&index=0&id=51fc2255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc2255",
  null
  
)

export default component.exports